import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Typography, Link } from '@mui/material';
import { useOperator } from './hooks/useOperator';
import { OperatorTable } from './OperatorTable';
import { CreateOperator } from './CreateOperator';
import { t } from 'i18next';
import { OperatorItem } from './components';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import { theme } from '@store';
import { ArrowBack } from '@mui/icons-material';

export const Operator = () => {
  const {
    totalCount,
    entries = [],
    isLoading,
    selectedOperatorId,
    handleCloseDrawer,
    handleOpenOperatorDetails,
    isDrawerOpen,
    isInitialFilters,
  } = useOperator();

  return (
    <>
      <Box
        sx={{
          cursor: 'pointer',
          [theme.breakpoints.down('md')]: {
            display: 'none',
          },
          width: 'fit-content',
        }}
      >
        <Link
          href={'/admin'}
          underline='always'
          sx={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <ArrowBackIcon sx={{ fontSize: '1.5rem' }} color='primary' />
          <Typography sx={{ color: 'primary' }}>
            {t('general.backToPrevious')}
          </Typography>
        </Link>
      </Box>
      <Box
        sx={{
          paddingTop: '1rem',
          gap: '1rem',
          display: 'flex',
          flexDirection: 'column',
          pb: '1rem',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box
              sx={{
                cursor: 'pointer',
                [theme.breakpoints.up('md')]: {
                  display: 'none',
                },
                width: 'fit-content',
              }}
            >
              <Link
                href={'/admin'}
                underline='always'
                sx={{
                  gap: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                }}
              >
                <ArrowBack
                  sx={{ fontSize: '2rem', color: 'rgba(0, 0, 0, 0.56)' }}
                  color='primary'
                />
              </Link>
            </Box>
            <Typography variant='h4'>
              {t('adminPanel.operators.title')}
            </Typography>
          </Box>
          <CreateOperator
            handleOpenOperatorDetails={handleOpenOperatorDetails}
          />
        </Box>
      </Box>
      {entries.length === 0 && isInitialFilters && !isLoading ? (
        <Box
          sx={{
            height: 'calc(100vh - 310px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <PermPhoneMsgIcon
            sx={{ width: 56, height: 56, mb: 2 }}
            color='primary'
          />
          <Typography variant='h6'>
            {t('adminPanel.operators.noResults.title')}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.disabled' }}>
            {t('adminPanel.operators.noResults.subTitle')}
          </Typography>
        </Box>
      ) : (
        <OperatorTable
          rows={entries}
          totalCount={totalCount}
          onSelectOperator={handleOpenOperatorDetails}
          loading={isLoading}
          selectedRowId={selectedOperatorId}
        />
      )}
      {selectedOperatorId && (
        <OperatorItem
          open={isDrawerOpen}
          itemId={selectedOperatorId}
          handleClose={handleCloseDrawer}
        />
      )}
    </>
  );
};
